export default "__VITE_ASSET__fR7ObyoT__"